import React from "react";
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  intro?: string;
  tone?: "light" | "dark";
  align?: "left" | "center";
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = "light",
  align = "center"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  const alignment = align === "center" ? "mx-auto text-center" : "";
  return <div className={`max-w-[760px] ${alignment}`} data-id="element-262" data-mp="bkn652uzpnmw">
      <span className={`text-xs font-bold uppercase tracking-[2.5px] ${dark ? "text-gold" : "text-gold-dark"}`} data-id="element-263" data-mp="bkvimtn7aqxk">
        {eyebrow}
      </span>
      <h2 className={`display-title mt-2 text-[clamp(36px,5.2vw,64px)] md:mt-3 ${dark ? "text-white" : "text-ink"}`} data-id="element-264" data-mp="1uk7am16tfgn">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-base md:mt-5 md:text-[17px] ${dark ? "text-haze" : "text-muted"}`} data-id="element-265" data-mp="6raiow21rmvq">{intro}</p>}
    </div>;
}